"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupDisplaysDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const approximate_daily_impressions_1 = require("./commons/approximate-daily-impressions");
class GroupAudienceHourDto {
    start;
    end;
    count;
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], GroupAudienceHourDto.prototype, "start", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], GroupAudienceHourDto.prototype, "end", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], GroupAudienceHourDto.prototype, "count", void 0);
class GroupAudienceStatDto {
    day_of_week;
    hours;
    daily_total;
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], GroupAudienceStatDto.prototype, "day_of_week", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GroupAudienceHourDto),
    __metadata("design:type", Array)
], GroupAudienceStatDto.prototype, "hours", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], GroupAudienceStatDto.prototype, "daily_total", void 0);
class GroupDisplaysDto {
    name;
    groupId;
    ownerId;
    displayIds;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    audience_stats;
    last_updated_audience_stats;
}
exports.GroupDisplaysDto = GroupDisplaysDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], GroupDisplaysDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], GroupDisplaysDto.prototype, "groupId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], GroupDisplaysDto.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GroupDisplaysDto.prototype, "displayIds", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => approximate_daily_impressions_1.ApproximateDailyImpressions)
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", approximate_daily_impressions_1.ApproximateDailyImpressions)
], GroupDisplaysDto.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => GroupAudienceStatDto),
    __metadata("design:type", Array)
], GroupDisplaysDto.prototype, "audience_stats", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], GroupDisplaysDto.prototype, "last_updated_audience_stats", void 0);
